// Warehouse commands never persist a whole browser collection.
const WarehouseAPI = {
    _pending: null,
    _drafts: new Map(),
    capabilities:null,
    draftId(kind, data) {
        const key=AuthManager._epoch+':'+kind+':'+JSON.stringify(data);
        if(!this._drafts.has(key))this._drafts.set(key,crypto.randomUUID());
        return this._drafts.get(key);
    },
    clear() { this._drafts.clear();this.capabilities=null;this.clearWarehouseData(); },
    clearWarehouseData() { for(const key of ['inventory','warehouseCategories','warehouseRequests','purchaseOrders','projects','warehouseParticipants'])this.cache(key,[],true); },
    participant(id) { return (FileStorage.dataStore.warehouseParticipants || []).find(s=>s.id===id) || StudentService.getStudent(id); },
    async refreshCapabilities(notify=true) {
        const epoch=AuthManager._epoch,previous=this.capabilities;
        try {
            const response=await fetch('/api/warehouse/capabilities',{cache:'no-store'});
            const data=await response.json();
            if(!response.ok || !data.success || typeof data.canManage!=='boolean')throw new Error('No se pudo verificar el permiso de almacén. Recarga para reintentarlo.');
            if(epoch!==AuthManager._epoch)return;
            this.capabilities={canManage:data.canManage,expiresAt:data.expiresAt};
        }catch(e){
            if(epoch!==AuthManager._epoch)return;
            this.capabilities=null;this.clearWarehouseData();
            if(!notify)throw e;
        }
        const changed=previous?.canManage!==this.capabilities?.canManage || previous?.expiresAt!==this.capabilities?.expiresAt;
        if(changed){
            this.clearWarehouseData();
            if(notify && document.querySelector('.warehouse-container'))App.render();
        }
    },
    cache(key, rows, replace=false) {
        const current=FileStorage.dataStore[key] || [];
        FileStorage.dataStore[key]=replace?rows:current.filter(r=>!rows.some(n=>n.id===r.id)).concat(rows);
        const storageKey=Object.keys(FileStorage.keyMapping).find(k=>FileStorage.keyMapping[k]===key);
        if(storageKey)BrowserState.setItem(storageKey,JSON.stringify(FileStorage.dataStore[key]));
    },
    async load() {
        const epoch=AuthManager._epoch,role=AuthManager.currentUser?.role;
        if(role==='student')await this.refreshCapabilities(false);
        if(epoch!==AuthManager._epoch)throw new Error('La sesión ha cambiado.');
        const resources=role==='rrhh'&&!AuthManager.hasModule('almacen')?[['orders','purchaseOrders']]:[['inventory','inventory'],['categories','warehouseCategories'],['requests','warehouseRequests'],['projects','projects'],...(AuthManager.canManageWarehouse()||AuthManager.hasModule('almacen')?[['orders','purchaseOrders'],['participants','warehouseParticipants']]:[])];
        const result=await Promise.all(resources.map(async([path,key])=>{
            const res=await fetch('/api/warehouse/'+path,{cache:'no-store'}),data=await res.json();
            if(!res.ok || !data.success || !Array.isArray(data[key]))throw new Error(data.error || 'No se pudo cargar el almacén.');
            return [key,data[key]];
        }));
        if(epoch!==AuthManager._epoch)throw new Error('La sesión ha cambiado.');
        result.forEach(([key,rows])=>this.cache(key,rows,true));
    },
    async command(path, method, body, apply) {
        const epoch=AuthManager._epoch;
        if(this._pending?.epoch===epoch)return null;
        const pending={epoch};this._pending=pending;
        const controls=Array.from(document.querySelectorAll('.warehouse-container button, #modal-overlay button')).map(el=>[el,el.disabled]);
        controls.forEach(([el])=>{el.disabled=true;});
        try {
            const response=await fetch('/api/warehouse/'+path,{method,headers:{'Content-Type':'application/json','X-SICAF-CSRF':AuthManager.getCsrfToken()},body:JSON.stringify(body)});
            const data=await response.json().catch(()=>null);
            if(epoch!==AuthManager._epoch)return null;
            if(!response.ok || !data?.success)throw new Error(data?.error || 'No se pudo confirmar el guardado. Recarga el almacén para comprobarlo.');
            apply?.(data);
            // A confirmed creation ends this draft; a later identical form is a new intent.
            if(method==='POST') {
                const ids=new Set([body.id,...(body.items || []).map(item=>item.id)].filter(Boolean));
                for(const [key,id] of this._drafts)if(ids.has(id))this._drafts.delete(key);
            }
            return data;
        } catch(e) {
            if(epoch===AuthManager._epoch)Utils.showToast(e.message || 'No se pudo guardar. Conservamos el formulario.','error');
            return null;
        } finally {
            if(this._pending===pending)this._pending=null;
            controls.forEach(([el,disabled])=>{if(el.isConnected)el.disabled=disabled;});
        }
    }
};
window.WarehouseAPI=WarehouseAPI;
